import { ReactComponent as BookmarkOutline } from 'assets/icons/icon-bookmark-outline.svg';

export default BookmarkOutline;
